// extracted by mini-css-extract-plugin
export var badges = "footer-module--badges--6AYW+";
export var downloadButtons = "footer-module--download-buttons--bOJgE";
export var footer = "footer-module--footer--ov5Kw";
export var footerList = "footer-module--footer-list--O6JTb";
export var grid = "footer-module--grid--995Sf";
export var help = "footer-module--help--iKmne";
export var links = "footer-module--links--yXqoa";
export var logo = "footer-module--logo--mrnDn";
export var socialMedia = "footer-module--social-media--MuKKC";